import { RegisterSearchConditionsApi } from "@/features/accounts/shared/services/register-search-conditions-api";
import { RegisterSearchConditionsPostRequestModel } from "@/features/accounts/shared/services/register-search-conditions-model";

/// 検索条件登録処理
export class RegisterSearchConditionsService {
  private registerSearchConditionsApi = new RegisterSearchConditionsApi();

  /**
   * 検索条件登録API実行
   */
  public async registerSearchConditions(param: RegisterSearchConditionsPostRequestModel) {
    return await this.registerSearchConditionsApi.registerSearchConditions(param);
  }
}
